/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCcVisa = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m18.798 10.674.44 2.179h-1.206z" />
        <path d="M22 4v16H2V4zM8.306 9.106l-1.513 3.95-.613-3.358c-.072-.375-.355-.592-.67-.592H3.033L3 9.274c.508.115 1.085.298 1.435.494.214.12.275.225.345.51l1.16 4.631h1.538l2.356-5.803zm2.152 0L9.255 14.91h1.455l1.203-5.803zm8.126 0a.662.662 0 0 0-.619.426l-2.182 5.377h1.527l.303-.867h1.866l.176.867H21l-1.174-5.803zM14.766 9c-1.437 0-2.45.789-2.457 1.918-.01.836.722 1.302 1.273 1.58.567.284.757.467.755.72-.005.39-.452.562-.871.569-.71.011-1.13-.192-1.463-.352l-.03-.015-.264 1.272c.34.16.967.301 1.617.308 1.528 0 2.528-.779 2.533-1.986.003-.916-.732-1.314-1.32-1.633-.395-.214-.724-.392-.718-.667.004-.208.196-.43.617-.486a2.67 2.67 0 0 1 1.434.26l.255-1.23A3.8 3.8 0 0 0 14.767 9z" />
      </g>
    </g>
  </Icon>
);
export { SvgCcVisa as CcVisa };
